import React from 'react';
import {Tab} from "@headlessui/react"
import {concatenate} from "services/string";

enum Position {FIRST, MIDDLE, LAST}

type Props = {
    position: Position
    disabled?: boolean
    children: React.ReactText
}

const positionClasses: Record<Position, string> = {
    [Position.FIRST]: 'rounded-l-md',
    [Position.MIDDLE]: '',
    [Position.LAST]: 'rounded-r-md',
}

function TabButton(props: Props) {
    const {position, children} = props

    const baseClasses = 'relative inline-flex items-center px-3 py-1 border text-sm font-medium focus:outline-none ui-focus-visible:outline-offset-2 ui-focus-visible:outline-2 ui-focus-visible:outline-brand'
    const unselectedClasses = 'border-gray-300 bg-white hover:bg-gray-50 text-gray-700'
    const selectedClasses = 'border-transparent bg-brand hover:brand text-white'
    const unselectedDisabledClasses = "text-gray-700 bg-gray-200 cursor-not-allowed"
    const selectedDisabledClasses = "text-gray-100 bg-gray-500 cursor-not-allowed"

    return (
        <Tab
            disabled={props.disabled}
            className={({selected}) => concatenate(
                (selected && !props.disabled) ? selectedClasses : null,
                (!selected && !props.disabled) ? unselectedClasses : null,
                (selected && props.disabled) ? selectedDisabledClasses : null,
                (!selected && props.disabled) ? unselectedDisabledClasses : null,
                positionClasses[position],
                baseClasses)
            }
        >
            {children}
        </Tab>
    );
}

TabButton.positions = Position

TabButton.defaultProps = {
    position: Position.MIDDLE
}

export default TabButton;